import { connect } from 'react-redux';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { CANCELLATION_OUTSIDE_EU } from '../../products';
import ProductLayout from '../../common/main-layout/ProductLayout';
import NewSmallCardLayout from '../../common/components/small-card-layout/NewSmallCardLayout';
import { useProductData } from '../../common/hook/useProductData';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CANCELLATION_OUTSIDE_EU;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const sharedTexts = {
  title: 'cancellationOutsideEUTitle',
  persuasionContent: 'cancellationOutsideEUPersuasionContent',
  readMoreContent: 'cancellationOutsideEUReadMoreModalContent'
};
const mainCardTranslations = {
  ...sharedTexts,
  additionalInformation: 'cancellationOutsideEUAdditionalInformation',
  abstractContent: 'cancellationOutsideEUAbstract',
  upSell: 'cancellationOutsideEUUpSellText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'cancellationOutsideEUAbstractSmallCard',
    upSell: 'cancellationOutsideEUUpSellTextSmallCard'
  }
};
const CancellationOutsideEu = _ref => {
  let {
    className,
    form,
    isSelected,
    order,
    sellSpecification,
    productPosition,
    layoutType = MAIN_CARD_LAYOUT
  } = _ref;
  const texts = translations[layoutType] || {};
  const {
    productData,
    rootElement
  } = useProductData({
    productId: PRODUCT_ID,
    order,
    productName: PRODUCT_NAME,
    productPosition,
    isSelected,
    form,
    sellSpecification,
    className,
    texts,
    layoutType,
    productType: 'traveler'
  });
  if (!productData) {
    return null;
  }
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(NewSmallCardLayout, {
        productData: productData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: productData,
        ref: rootElement
      });
  }
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  return {
    isSelected: getSelected(CANCELLATION_OUTSIDE_EU.name, form)(state)
  };
};
export default connect(mapStateToProps)(CancellationOutsideEu);
//# sourceMappingURL=CancellationOutsideEu.js.map